import {ErrorBoundary, ErrorBoundaryProps} from "@sentry/react";

import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";

export const UpErrorBoundary = ({children, ...rest}: ErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallback={ErrorFallback} {...rest}>
      {children}
    </ErrorBoundary>
  );
};
